<template>
  <div>
    <!-- 弹框 -->
    <div>
      <!-- 阿里验证码 -->
      <Verify ref="verify" />
      <!-- 登录 -->
      <el-dialog
        :visible.sync="loginDialog"
        width="420px"
        :before-close="loginClose"
        :close-on-click-modal="false"
      >
        <div class="dialogBox" v-if="isFlag">
          <p>账号密码登录</p>
          <div class="phone">
            <el-input
              placeholder="输入手机号"
              v-model="signLogin.phone"
            ></el-input>
            <!-- <span>
              <img src="@/assets/img/icon2.png" alt />
            </span>-->
          </div>
          <el-input
            type="password"
            placeholder="密码"
            v-model="signLogin.passWord"
          ></el-input>
          <div class="forget" @click="forgetPwd">忘记密码？</div>
          <el-button style="background: #0091ff;color:#fff" @click="signIn"
            >登录</el-button
          >
          <div style="margin: 10px 0">or</div>
          <el-button @click="changeLogin">手机号快捷登录</el-button>
          <div class="agree">
            <div>
              点击
              <span style="margin-left: -4px;">登录</span>即表示已同意
            </div>
            <div @click="userAgreement">《第一财经》杂志网注册用户协议</div>
            <div @click="privacy">《隐私条款》</div>
          </div>
        </div>
        <div class="dialogBox" v-if="!isFlag">
          <p>手机号快捷登录</p>
          <el-input
            placeholder="输入手机号"
            v-model="fastLogin.phone"
          ></el-input>
          <div class="code">
            <el-input placeholder="验证码" v-model="fastLogin.code"></el-input>
            <span @click="getCode" v-if="showSendCode">获取验证码</span>
            <span v-else>{{ sendCode_ts }}</span>
          </div>
          <div style="color:#999999;margin-bottom: 14px;">
            未注册手机验证后自动注册
          </div>
          <el-button style="background: #0091ff;color:#fff" @click="fastLogIn"
            >登录</el-button
          >
          <div style="margin: 10px 0">or</div>
          <el-button @click="changeLogin">账号密码登录</el-button>
          <div class="agree">
            <div>
              点击
              <span style="margin-left: -4px;">登录</span>即表示已同意
            </div>
            <div @click="userAgreement">《第一财经》杂志网注册用户协议</div>
            <div @click="privacy">《隐私条款》</div>
          </div>
        </div>
      </el-dialog>
      <!-- 用户协议 -->
      <el-dialog
        :visible.sync="agreeDialog"
        width="800px"
        :before-close="agreeClose"
        :close-on-click-modal="false"
        class="agreeDialog"
      >
        <div class="agreeList">
          <h3>第一财经杂志网注册用户协议</h3>
          <ul>
            <li v-for="(item, i) in agreementList" :key="i">
              {{ item.content }}
            </li>
          </ul>
        </div>
      </el-dialog>
      <!-- 忘记密码 -->
      <el-dialog
        :visible.sync="resetPwdDialog"
        width="420px"
        :before-close="resetPwdClose"
        :close-on-click-modal="false"
        class="agreeDialog"
      >
        <div class="feedBackList">
          <h3>忘记密码</h3>
          <div class="box">
            <el-form
              :model="resetPwdForm"
              :rules="rule"
              ref="resetPwdForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item prop="phone">
                <el-input
                  placeholder="手机号"
                  v-model="resetPwdForm.phone"
                ></el-input>
                <span
                  @click="resetSendCode"
                  style="cursor: pointer;"
                  v-if="showBtnCode"
                  >发送验证码</span
                >
                <span v-else>{{ code_ts }}</span>
              </el-form-item>
              <el-form-item prop="code">
                <el-input
                  placeholder="验证码"
                  v-model="resetPwdForm.code"
                ></el-input>
              </el-form-item>

              <Verify ref="verify" />

              <el-form-item prop="passWord">
                <el-input
                  type="password"
                  placeholder="密码为6~16位数字、英文、符号，至少两种组合的字符"
                  v-model="resetPwdForm.passWord"
                ></el-input>
              </el-form-item>
              <el-form-item prop="again">
                <el-input
                  type="password"
                  placeholder="再次输入密码"
                  v-model="resetPwdForm.again"
                ></el-input>
              </el-form-item>
            </el-form>
            <el-button @click="resetPwd('resetPwdForm')">重置</el-button>

            <p>
              又想起来了，
              <span @click="goLogin">去登录</span>
            </p>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getlogin } from "@/api/public";
import {
  getEditPwd,
  getForgetCode,
  getFastCode,
  getFastLogin
} from "@/api/system";
import Verify from "./verify.vue";
export default {
  props: {
    loginDialogs: [String, Boolean]
  },
  inject: ["reload"],
  data() {
    return {
      // 弹框
      loginDialog: false, // 登录弹框
      agreeDialog: false, // 用户协议弹框
      isFlag: true, //登录方式，ture：账号密码
      isLogin: false, //是否登陆
      avatar: require("@/assets/img/my.png"), //登陆成功后用户头像
      name: "登录 / 注册", //用户名
      // 账号密码登录
      signLogin: {
        phone: "",
        passWord: ""
      },
      // 快速登录
      fastLogin: {
        phone: "",
        code: ""
      },
      // 用户协议
      agreementList: [
        {
          content:
            "1. 第一财经网向注册用户提供用户评论留言、社区发帖跟帖等服务。未实名注册的用户仅可浏览第一财经网内容，不可使用上述服务。"
        },
        {
          content: "2. 用户注册时须提交中国境内手机号。"
        },
        {
          content:
            "3. 注册用户可自主选择昵称、上传头像,昵称和头像经审核通过后显示在前端。"
        },
        {
          content: "4. 注册用户可修改昵称和头像,每30天可修改一次。"
        },
        {
          content: "5. 注册用户发布的内容经审核通过后显示。"
        },
        {
          content:
            "6. 注册用户发布在第一财经网的内容,其知识产权属于发布有关内容的用户,第一财经网有权记录、保存、展示有关内容。"
        },
        {
          content:
            "7. 第一财经网严格保护用户个人隐私,除法律规定的情况之外,不向第三方透露用户注册账号及使用账号过程中产生的个人信息。"
        },
        {
          content:
            "8. 注册用户在第一财经网/APP上的一切活动、发布的一切内容,均须遵守中国法律和互联网信息管理规定。对于违反法律和规定的用户,将采取冻结账号、移交司法等措施。"
        },
        {
          content: "9. 用户注册第一财经网账号,视为同意以上协议。"
        }
      ],
      resetPwdDialog: false, //重置密码
      resetPwdForm: {
        phone: "",
        code: "",
        passWord: "",
        again: ""
      },
      uId: "",
      rule: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号码"
          }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        passWord: [
          {
            required: true,
            message: "请输入密码为6~16位数字、英文、符号，至少两种组合的字符",
            trigger: "blur"
          },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\\(\\)])+$)([^(0-9a-zA-Z)]|[\\(\\)]|[a-zA-Z]|[0-9]){6,16}$/,
            message: "请输入密码为6~16位数字、英文、符号，至少两种组合的字符"
          }
        ],
        again: [{ required: true, message: "再次输入密码", trigger: "blur" }]
      },
      //获取验证码倒计时
      showSendCode: true,
      sendCode_ts: "发送验证码",
      sendSec: 60,
      //忘记密码
      showBtnCode: true,
      code_ts: "获取验证码",
      sec: 60
    };
  },
  watch: {
    loginDialogs(newValue, oldValue) {
      this.loginDialog = newValue;
      this.signLogin = {
        phone: "",
        passWord: ""
      };
      this.fastLogin = {
        phone: "",
        code: ""
      };
    }
  },
  methods: {
    // 弹框
    // 关闭登录弹框
    loginClose() {
      this.loginDialog = false;
      this.$emit("child-event", false);
    },
    // 切换登录方式
    changeLogin() {
      this.isFlag = !this.isFlag;
    },
    // 用户密码登录
    signIn() {
      if (this.signLogin.phone == "" || this.signLogin.passWord == "") {
        this.$message.error("用户名或密码不能为空！");
      } else {
        if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.signLogin.phone)) {
          this.$message.error("手机号输入错误，请输入正确的手机号");
        } else {
          var params = {
            login_name: this.signLogin.phone,
            pwd: this.signLogin.passWord,
            mobile: "pc",
            device: {
              name: "pc", //固定传字符串PC
              token: "pc", //固定传字符串PC
              type: "pc" //固定传字符串PC
            }
          };
          getlogin(params).then(res => {
            var token = res.data.data.token;
            this.loginDialog = false;
            this.isLogin = true;
            this.avatar = res.data.data.avatar;
            this.name = res.data.data.nickname;
            this.resetSetItem("isLogin", true);
            this.resetSetItem("Authorization", token);
            this.resetSetItem("userInfo", JSON.stringify(res.data.data));
            this.$emit("token", token);
            this.signLogin.phone = "";
            this.signLogin.passWord = "";
            if (res.data.data.warning_message != null) {
              this.$message.success(res.data.data.warning_message);
            } else {
              this.$message.success("登录成功");
            }
            this.reload();
          });
        }
      }
    },
    // 打开用户协议弹窗
    userAgreement() {
      this.loginDialog = false;
      this.agreeDialog = true;
    },
    // 关闭用户协议弹窗
    agreeClose() {
      this.agreeDialog = false;
      this.$emit("child-event", false);
    },
    // 隐私协议
    privacy() {
      this.loginDialog = false;
      this.$router.push({ path: "/privacy" });
    },
    // 快速登录
    fastLogIn() {
      if (this.fastLogin.phone == "" || this.fastLogin.code == "") {
        this.$message.error("");
      } else {
        var params = {
          code: this.fastLogin.code,
          login_name: this.fastLogin.phone,
          mobile: "pc",
          device: {
            name: "pc", //固定传字符串PC
            token: "pc", //固定传字符串PC
            type: "pc" //固定传字符串PC
          }
        };
        getFastLogin(params).then(res => {
          var token = res.data.data.token;
          this.loginDialog = false;
          this.isLogin = true;
          this.avatar = res.data.data.avatar;
          this.name = res.data.data.nickname;
          this.userId = res.data.data.id;
          this.resetSetItem("isLogin", true);
          this.resetSetItem("Authorization", token);
          this.resetSetItem("userInfo", JSON.stringify(res.data.data));
          if (res.data.data.warning_message != null) {
            this.$message.success(res.data.data.warning_message);
          } else {
            this.$message.success("登录成功");
          }
          this.reload();
        });
      }
    },
    // 快速登录 获取验证码
    getCode() {
      if (this.fastLogin.phone == "") {
        this.$message.error("请输入手机号");
      } else {
        this.$refs.verify.showCaptcha.then(res => {
          var params = {
            login_name: this.fastLogin.phone,
            type: "0",
            ...res
          };
          getFastCode(params)
            .then(res => {
              this.$message.success("发送成功，请注意查看手机");
              var timer = setInterval(() => {
                this.sendSec = this.sendSec - 1;
                this.sendCode_ts = this.sendSec + "S后重试";
                this.showSendCode = false;
                if (this.sendSec === 0) {
                  clearInterval(timer);
                  this.sendSec = 60;
                  this.sendCode_ts = this.sendSec + "S后重试";
                  this.showSendCode = true;
                }
              }, 1000);
            })
            .catch(error => {
              this.$message.error("请输入正确的手机号");
            });
        });
      }
    },
    // 忘记密码
    forgetPwd() {
      this.loginDialog = false;
      this.resetPwdDialog = true;
      this.$nextTick(() => {
        this.$refs.resetPwdForm.resetFields();
      });
    },
    // 重置密码关闭弹框
    resetPwdClose() {
      this.resetPwdDialog = false;
      this.$emit("child-event", false);
    },
    resetSendCode() {
      if (this.resetPwdForm.phone == "") {
        this.$message.error("请输入手机号");
      } else {
        var params = {
          login_name: this.resetPwdForm.phone,
          type: "0"
        };
        getForgetCode(params)
          .then(res => {
            this.$message.success("发送成功，请注意查看手机");
            this.uId = res.data.data.id;
            var timer = setInterval(() => {
              this.sec = this.sec - 1;
              this.code_ts = this.sec + "S后重试";
              this.showBtnCode = false;
              if (this.sec === 0) {
                clearInterval(timer);
                this.sec = 60;
                this.code_ts = this.sec + "S后重试";
                this.showBtnCode = true;
              }
            }, 1000);
          })
          .catch(error => {
            this.$message.error("请输入正确的手机号");
          });
      }
    },
    // 忘记密码
    resetPwd(resetPwdForm) {
      this.$refs[resetPwdForm].validate(valid => {
        if (valid) {
          if (this.resetPwdForm.passWord == this.resetPwdForm.again) {
            var params = {
              id: this.uId,
              login_name: this.resetPwdForm.phone,
              pwd: this.resetPwdForm.passWord,
              code: this.resetPwdForm.code
            };
            getEditPwd(params).then(res => {
              this.resetPwdDialog = false;
              this.$message.success(res.data.data.returnmsg);
            });
          } else {
            this.$message.error("两次密码输入不一致");
          }
        } else {
          return false;
        }
      });
    },
    // 去登录
    goLogin() {
      if (localStorage.getItem("Authorization") == null) {
        this.resetPwdDialog = false;
        this.loginDialog = true;
        this.signLogin = {
          phone: "",
          passWord: ""
        };
        this.fastLogin = {
          phone: "",
          code: ""
        };
      } else {
        this.$message.error("您已登录，请先退出登录再进行登录！");
      }
    }
  },
  created() {
    this.loginDialog = this.loginDialogs;
  },
  components: {
    Verify
  }
};
</script>
<style lang="scss" scoped>
// // 弹框
>>> .el-dialog__body {
  padding: 0px 10%;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  text-align: center;
  margin-top: 5px;
}
.dialogBox {
  color: #333333;
  p {
    line-height: 24px;
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 40px;
  }
  .el-input {
    height: 50px;
  }
  .el-button {
    width: 300px;
    border-radius: 23px;
    color: #333333;
    font-size: 16px;
    padding: 14px 20px;
    border: 1px solid #dcdfe6;
  }
  .el-button:hover {
    background: #ffffff;
    border-color: #dcdfe6;
    color: #606266;
  }
  .forget {
    text-align: right;
    margin-bottom: 20px;
    cursor: pointer;
  }
  >>> .el-input__inner {
    border: none;
    border-bottom: 1px solid #e6e6e6;
    border-radius: 0;
    height: 34px;
    padding-left: 0;
  }
  .phone {
    position: relative;
    height: 60px;
    span {
      position: absolute;
      right: 0;
      top: 4px;
    }
  }
  .code {
    position: relative;
    margin-top: 10px;
    span {
      font-size: 12px;
      position: absolute;
      right: 0;
      top: 10px;
      cursor: pointer;
    }
  }
  .agree {
    margin-top: 10px;
    padding-bottom: 30px;
    cursor: pointer;
    div {
      line-height: 28px;
      color: #0091ff;
    }
    div:first-child {
      color: #b6b6b6;
    }
  }
}
.agreeDialog {
  >>> .el-dialog__body {
    padding: 0px 5%;
    margin-top: 5px;
  }
}
.agreeList {
  color: #333333;
  h3 {
    font-size: 30px;
    line-height: 36px;
  }
  ul {
    text-align: left;
    // margin-left: 2%;
    margin-top: 20px;
    padding-bottom: 40px;
    li {
      line-height: 22px;
      border-bottom: 1px solid #eeeeee;
      padding: 10px 0;
    }
  }
}
.feedBackList {
  // padding: 0 20px;
  h3 {
    font-size: 30px;
    line-height: 36px;
    margin-bottom: 10px;
  }
  .el-textarea {
    margin-top: 20px;
  }
  >>> .el-textarea__inner {
    border: 1px dashed #dcdfe6;
    border-radius: 0;
  }
  >>> .el-input__inner {
    border: none;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0px;
    padding: 0;
  }
  .box {
    padding: 20px;
    >>> .el-form-item {
      margin-bottom: 4px;
      position: relative;
      span {
        position: absolute;
        right: 0;
        bottom: 17px;
        font-size: 14px;
      }
    }
    >>> .el-form-item__content {
      margin-left: 0 !important;
      .el-form-item__error {
        top: 80%;
      }
    }
  }
  .el-input {
    margin-bottom: 15px;
  }
  .el-button {
    width: 300px;
    border-radius: 23px;
    background: #0099f1;
    color: #fff;
    padding: 14px 20px;
    margin: 20px 0 10px 0;
    font-size: 16px;
  }
  p {
    margin-bottom: 20px;
    span {
      color: #0091ff;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loginDialog.vue